import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";
import VstVisualRender from "@/pages/VstVisualRender";
import { LocaleProvider } from "@/context/LocaleContext";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    {window.location.pathname === "/vst-visual-render" ? <VstVisualRender /> : <LocaleProvider><App /></LocaleProvider>}
  </React.StrictMode>,
);
